
import { axios } from '../handlers/RequestHandler';
import { URL } from '../config.js';
import store from '../store/store.js';
import Notification from '../handlers/Notification.js';



export const fetchCompany = () => {
	return axios.get(URL + store.getState().company.id)
			.then( res => {
				return res.data;
			} ).catch((err) => {
				return {error:{data:'Company id '+store.getState().company.id} }
			});
}

/* export const fetchPayment = id => {
	return axios.get(URL + store.getState().company.id + '/forms/' + id)
			.then( res => {
				return res.data;
			} )
}
 */

export const fetchOrder = (id, loadPayments = false) => {
	return axios.get(`${URL + store.getState().company.id}/orders/${id}?with=branch,orderProviders.provider,taxes.coupon${(!loadPayments ? '' : ',payments')}`)
		.then( res => {
			//console.log('fetchOrder api',res.data)
			return res.data;
		}).catch((err) => {
			return {error:{data:'Order id '+id} }
		});
	
}

export const fetchProvider = id => {
	return axios.get(URL + store.getState().company.id + '/providers/' + id + "?with=order.branch")
			.then( res => {
				return res.data;
			} ).catch((err) => {
				return {error:{data:'Provider id '+id} }
			});
}

export const fetchBranch = id => {
	return axios.get(URL + store.getState().company.id + '/branches/' + id )
			.then( res => {
				return res.data;
			} ).catch((err) => {
				return {error:{data:'Branch id '+id} }
			});
}

export const fetchProviders = () => {
	return axios.get(URL + store.getState().company.id + '/providers')
			.then( res => {
				return res.data;
			}).catch((err) => {
				return { error:{ data:'Providers list' } }
			});
}

export const fetchGood = id => {
	return axios.get(URL + store.getState().company.id + '/goods/' + id + "?with=branch")
			.then( res => {
				return res.data;
			} ).catch((err) => {
				return {error:{data:'Good id '+id} }
			});
}

export const fetchClientRating = id => {
	return axios.get(URL + store.getState().company.id + '/orders/' + id + '/client-ratings?with=order.branch')
			.then( res => {
				return res.data;
			} ).catch((err) => {
				return {error:{data:'Client rating id '+id} }
			});
}

export const fetchClient = id => {
	return axios.get(URL + store.getState().company.id + '/clients/' + id)
			.then( res => {
				return res.data;
			} ).catch((err) => {
				return {error:{data: 'Client id '+id} }
			});
}

export const fetchOrderProviderClient = (order_id, provider_id, client_id) => {
	return axios.all([ 
				fetchOrder(order_id),
				fetchProvider(provider_id),
				fetchClient(client_id)
			]).then( axios.spread( res => {
				return res.data;
			})).catch((err) => {
				return {error:{data:'OrderProviderClient id '+ order_id} }
			});
}

export const fetchCoupon = (coupon_id) => {
	return axios.get(`${URL + store.getState().company.id}/coupons/${coupon_id}`)
			.then((res) => {
				return res.data;
			}).catch((err) => {  
				return {error:{data:'Coupon id '+ coupon_id} }
			});
}

export const updateProviderOrder = (payload) => {
	return (dispatch, getState) => {
		const { providerOrders, company, provider } = getState();
		const data = payload.data;
		const sameProvider = provider.id === data.provider_id;
		const prevProviderOrder = { ...providerOrders };
		if(sameProvider){
			const findIndex = prevProviderOrder.data.findIndex((providerData) => providerData.order_id === data.order_id);
			if(findIndex !== -1){
				prevProviderOrder.data[findIndex] = { ...prevProviderOrder.data[findIndex], ...data };
				dispatch({
					type: 'FETCH_PROVIDER_ORDERS',
					providerOrders: {
						...providerOrders,
						data: prevProviderOrder.data
					}
				})
			} else if (payload.action === "assigned" && providerOrders.current_page === 1 && provider.id){
				let url_host = `${URL + company.id}/providers/${provider.id}/order-providers?page=1&sort_by=created_at,desc`;
				axios.get(url_host)
					.then((res) => {
						dispatch({
							type: 'FETCH_PROVIDER_ORDERS',
							providerOrders: res.data
						})
					}).catch((err) => {
						Notification.show({
							type: "error", 
							title:`Error ${err && err.data && err.data.error_code}`, 
							msg: err && err.data && err.data.description
						});
						dispatch({
							type: "REMOVE_LOADING"
						});
					});
			}
		}
	}
    
}

export const updateBranch = (branchUpdate) => {
	return (dispatch, getState) => {
		const { branch } = getState();
		if(branch && branch.id){
			dispatch({ type: "FETCH_BRANCH", branchUpdate });
		}
	}
}



// WEBPACK FOOTER //
// ./src/api/ondemand.js